import { render, staticRenderFns } from "./marking.vue?vue&type=template&id=092d9d32&scoped=true&"
import script from "./marking.vue?vue&type=script&lang=js&"
export * from "./marking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092d9d32",
  null
  
)

export default component.exports